export default __webpack_public_path__ + "static/media/detective-svgrepo-com.d82e53cd.svg";